import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { UserProvider, useUser } from './hooks';
import { Toast } from 'react-frontier';
import { FrontierProvider } from 'react-frontier-v2';
import { APIProvider } from '@vis.gl/react-google-maps';
import ReactDOM from 'react-dom/client';
import RouterComponent from './Router';
import API, { GOOGLE_KEY } from './API';
import moment from 'moment';

import 'semantic-ui-css/semantic.min.css'
import 'frontier-css/css/frontier.css';

import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
  resources: {},
  lng: "es",
  fallbackLng: "es",
  interpolation: { escapeValue: false }
});

const MOMENT_SPANISH_LOCALE = {
	months: 'Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre'.split('_'),
	monthsShort: 'Ene_Feb_Mar_Abr_May_Jun_Jul_Ago_Sep_Oct_Nov_Dic'.split('_'),
	longDateFormat: {
		LT: 'h:mm a',
		LTS: 'h:mm:ss a',
		L: 'DD/MM/YYYY',
		LL: 'D MMMM YYYY',
		LLL: 'D MMMM YYYY h:mm a',
		LLLL: 'dddd D MMMM YYYY h:mm a'
	}
}
moment.updateLocale('es', MOMENT_SPANISH_LOCALE);

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);

var Root = ()=>{
	var { login: is_login, user } = useUser();
	var is_auth = !user && window.location.pathname==='/auth';

	useEffect(()=>{
		var now = moment().unix();
		var login = API.getToken();
		if((!login || now>(login.expires-30)) && !is_auth){
			var auth_url = API.getAuthUrl();
			if(!auth_url) return;
			window.location.href = auth_url
		}
		var logoutEvent = ()=>{
			if(!is_login){
				var auth_url = API.getAuthUrl();
				if(!auth_url) return;
				window.location.href = auth_url;
			}
		}
		window.addEventListener('user_logout', logoutEvent);
		return ()=>{
			window.removeEventListener('user_logout', logoutEvent);
		}
	}, [is_login]);

	var RouterNav = RouterComponent();

	return <UserProvider>
		<APIProvider apiKey={GOOGLE_KEY}>
			<FrontierProvider locale='es'>
			<Toast.Provider>
				<RouterProvider router={RouterNav} future={{ v7_startTransition: true }} />
			</Toast.Provider>
			</FrontierProvider>
		</APIProvider>
	</UserProvider>
}

root.render(<Root />)
